import { Link } from "gatsby"
import React, { useContext } from "react"
import Menu from "../menu/menu.js"
import "./style.scss"
import { ThemeContext } from "../../context/ThemeContext"
import { MENUS } from "../../data/navigation"
import MenuMobile from "../menuMobile/menuMobile.js"

const Navbar = () => {
  const theme = useContext(ThemeContext)

  function open(menu) {
    theme.setCurrentMenu(menu)
  }

  function close() {
    theme.setCurrentMenu(false)
  }

  function handleKeyDown(event) {
    if (event.key === "Escape") {
      close()
      theme.setToggleMobileMenu(false)
      theme.setCurrentSubMobileMenu(false)
    }
  }

  return (
    <header onKeyDown={handleKeyDown}>
      <div className={`backGround ${theme.backGroundColor}`}>
        <div className="container is-fullhd">
          <div className="inner-header">
            <div className="logo">
              <Link to="/">
                <img
                  alt="ACME Produzioni Logo - Vai alla Home"
                  width="150px"
                  height="56px"
                  id="logo"
                  src={theme.logo}
                />
              </Link>
            </div>
            <div className="navigation">
              <nav>
                {MENUS.map(menu => (
                  <Link
                    onClick={close}
                    onMouseEnter={() => open(menu)}
                    onFocus={() => open(menu)}
                    key={menu.id}
                    to={menu.to}
                  >
                    {menu.label}
                  </Link>
                ))}
              </nav>
            </div>
            <div className="social">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/acmeproduzioni/"
              >
                Fb
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.instagram.com/acmeproduzioni_official/"
              >
                Ig
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/company/acme-produzioni/"
              >
                In
              </a>
            </div>
          </div>
        </div>
        <Menu menu={theme.currentMenu} />
        <MenuMobile toggle={theme.toggleMobileMenu} MENUS={MENUS} />
      </div>
    </header>
  )
}

export default Navbar
